import styled from 'styled-components';

export const NftDetailsPlainWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const NftAdditionalInfoTitle = styled.div`
  color: var(--v3-text-color);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.18px;
  margin-top: 40px;
`;

export const NftDetailsPlainSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const NftDetailsPlainSectionTitle = styled.h4`
  color: var(--v3-text-color);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.18px;
  margin: 0;
`;

export const NftCreatorSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 24px;
`;

export const NftPropertiesTitle = styled.div`
  color: var(--v3-text-color);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.16px;
  margin: 20px 0 16px;
`;
